import { number } from 'prop-types';
import { Log } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';

const _logger = Log.create('Assigment-Service');
const T = Translator.create();
const token: any = localStorage.getItem('access_token');
let _apiClient: ApiClient;

export class StorageManagementService {

    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetGeneralStatisticsAsync(params: any) {
        return _apiClient.RequestAsync('GET', 'api/storage/GetGeneralStatistics', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetFilesAddedActivitiesStatisticsAsync(params: any) {
        return _apiClient.RequestAsync('GET', 'api/storage/GetTermListStatistics', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetActivityFilesStatisticsByTermAsync(params: { termId: string }) {
        return _apiClient.RequestAsync('POST', 'api/storage/GetActivityFilesStatisticsByTerm', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }


    public async RequestGetActivityFilesListByTermAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/storage/GetActivityFilesListByTerm', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestDeleteActivityFilesAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/storage/DeleteOrReturnFiles', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).then((result: any) => {
                return result;
            }).catch((response) => {
                return response;
            });
    }

    public async RequestDownloadActivityFilesAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/storage/DownloadStorageFiles', params, token)
            .then((responseData: any) => {
                return responseData.blob();
            })
            .then((data: any) => 
                data.arrayBuffer()
            )
            .then((res: any) => {
                const arrayBuffer = res
                const blob = new Blob( [ arrayBuffer ], { type: 'application/zip' } );	
                const objectURL = URL.createObjectURL( blob );
                const link = document.createElement('a');
                link.href = objectURL;
                link.setAttribute('download', "files");
                link.setAttribute('_target', 'blank');
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((response) => {
                return response;
            });
    }

    public async RequestRestoreActivityFilesAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/storage/DeleteOrReturnFiles', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).then((result: any) => {
                return result;
            }).catch((response) => {
                return response;
            });
    }

    public async RequestGetCommunicationFilesListAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/storage/GetCommunicationFilesList', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetCommunicationFilesStatisticsAsync(params: any) {
        return _apiClient.RequestAsync('GET', 'api/storage/GetCommunicationFilesStatistics', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetPersonelFilesListAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/storage/GetPersonalFilesList', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetOtherFilesListAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/storage/GetOtherFilesList', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }
}

